'use client'

import { Image, Spacer, Text } from '@vinted/web-ui'

import { useTranslate } from '@marketplace-web/shared/i18n'
import { useAsset } from '@marketplace-web/shared/ui-helpers'

const OtherDetails = () => {
  const translate = useTranslate('business.homepage.what_else')
  const asset = useAsset('/assets/business-accounts')

  function getImageSrc(src: string) {
    return asset(`${src}.svg`, { theme: { dark: `${src}_dark.svg` } })
  }

  return (
    <div className="content-block u-ui-padding-top-large@portables">
      <div className="content-block__content u-ui-padding-bottom-x4-large@desktops u-ui-padding-bottom-x-large@portables">
        <div className="u-clearfix">
          <div className="content-block__heading u-ui-padding-vertical-x2-large@desktops u-ui-padding-top-large@portables u-ui-padding-bottom-x-large@portables">
            <Text as="span">
              <span className="c-text--responsive-small-heading">{translate('title')}</span>
            </Text>
          </div>

          <div className="content-block__blocks">
            <div className="row">
              <div className="grid6 u-ui-padding-bottom-x2-large@portables">
                <div className="row">
                  <div className="grid2 u-ui-padding-bottom-large@portables">
                    <Image src={getImageSrc('paper-document')} size={Image.Size.Large} />
                  </div>
                  <div className="grid10">
                    <Text as="span" width={Text.Width.Parent} html>
                      <span className="c-text--responsive-large-title">
                        {translate('business_details.title')}
                      </span>
                    </Text>
                    <Spacer size={Spacer.Size.Medium} />
                    <Text as="span" width={Text.Width.Parent} html>
                      <span className="c-text--responsive-small-body">
                        {translate('business_details.body')}
                      </span>
                    </Text>
                  </div>
                </div>
              </div>
              <div className="grid6">
                <div className="row">
                  <div className="grid2 u-ui-padding-bottom-large@portables">
                    <Image src={getImageSrc('geometric-shapes')} size={Image.Size.Large} />
                  </div>
                  <div className="grid10">
                    <Text as="span" width={Text.Width.Parent} html>
                      <span className="c-text--responsive-large-title">
                        {translate('policies.title')}
                      </span>
                    </Text>
                    <Spacer size={Spacer.Size.Medium} />
                    <Text as="span" width={Text.Width.Parent}>
                      <span className="c-text--responsive-small-body">
                        {translate('policies.body')}
                      </span>
                    </Text>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  )
}

export default OtherDetails
